/**
 * Single shared TanStack Query client for the app. Firebase reads are pushed
 * through `onSnapshot` listeners in their respective hooks, so the query
 * client mostly backs imperative fetches and callable invocations.
 */

import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
